module.exports = __webpack_public_path__ + "img/bg-upgpt-login.27835f96.jpg";